import config from "../config/application"
import { apiCall } from "./common/base.service"
import dictionary from "../config/dictionary"
import permission from "./permissions.service"

//url
const findUser = "/find/user"
const findAreaById = "/find/"
const findArea = "/find/type"
const register = "/register"
const deleteArea = "/delete"

class AreasService {
  getUsers(filterJson) {
    const url = `${config.data.providers.userArea.url}${findUser}`
    return apiCall("put", url, filterJson)
  }

  getAreas() {
    const url = `${config.data.providers.userArea.url}${findArea}`
    return apiCall("get", url)
  }

  getAreasByUser(id) {
    const url = `${config.data.providers.userArea.url}${findAreaById}${id}`
    return apiCall("get", url)
  }

  saveAreasByUser = async data => {
    const obj = {
      username: data.user.username,
      area: data.areas,
      society: data.user.society,
      status: 1,
      createdBy: data.createdBy,
    }

    const url = `${config.data.providers.userArea.url}${register}`
    const validPermission = await userArea.getPermissions(
      data.createdBy,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, obj)
  }

  deleteAreas = async (data,username) => {
    const newData = data.map(value => value.id)
    const url = `${config.data.providers.userArea.url}${deleteArea}`
    const validPermission = await userArea.getPermissions(
      username,
      dictionary.configApp.action.delete
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("delete", url, newData)
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_AREA,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}

const userArea = new AreasService()
export default userArea
